import { useTranslation } from "react-i18next";

export const ArchiveWarning = ({ company }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-3 text-sm">
      <p className="font-semibold text-destructive">
        {t("archiveCompany.irreversible", { name: company?.name })}
      </p>
      <ul className="list-disc space-y-1 ps-5 text-muted-foreground">
        <li>{t("archiveCompany.willCancelStripe")}</li>
        <li>{t("archiveCompany.willDeleteUsers")}</li>
        <li>{t("archiveCompany.willKeepFinancial")}</li>
        <li>{t("archiveCompany.willFreeEmail")}</li>
      </ul>
    </div>
  );
};
